module.exports = __webpack_public_path__ + "img/ic_live_help.4b1b3c5a.svg";